import React from 'react';
import { RestorePage, Save } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import { TooltipIconButton } from 'shared/components/abstract/interactables';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.editEnabled=false]
 * @param {Function} [props.saveChanges]
 * @param {string} [props.className='']
 */
export function CardSection({
  editEnabled = false, saveChanges = () => null, children, className = '',
}) {
  if (editEnabled && saveChanges) {
    return (
      <form
        className={`card-section ${className}`}
        onSubmit={(e) => {
          e.preventDefault();
          saveChanges();
        }}
      >
        {children}
      </form>
    );
  }
  return (
    <section className={`card-section ${className}`}>
      {children}
    </section>
  );
}

/**
 * @param {Object} props
 * @param {boolean} props.editEnabled
 * @param {boolean} [props.dirty=false]
 * @param {boolean} [props.disabled=false]
 * @param {Function} [props.clearChanges=null]
 * @param {React.ReactNode} [props.children=null]
 * @param {boolean} [props.hideClear=false]
 */
export function CardControls(props) {
  const {
    clearChanges = null,
    disabled = false,
    dirty = false,
    editEnabled,
    children = null,
    hideClear = false,
  } = props;

  return (
    <Grid
      container
      className="card-controls"
    >
      <Grid>
        {children}
      </Grid>
      { editEnabled && (
      <Grid className="card-controls-right">
        { dirty && (
        <>
          {!hideClear && (
          <TooltipIconButton className="clear" disabled={disabled} message="Clear changes" icon={RestorePage} onClick={clearChanges} />
          )}
          <TooltipIconButton className="save" message="Save changes" icon={Save} type="submit" disabled={disabled} />
        </>
        )}
      </Grid>
      )}
    </Grid>
  );
}
